(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["modal"] && !Shopify.designMode) return;
  try {
    class Modal {
    constructor() {
      this.modals = new Map();
      this.activeModal = null;
      this.init();
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      document.addEventListener('click', (e) => {
        console.log('Click event on:', e.target, 'with classes:', e.target.className);
        
        if (e.target.matches('[data-modal-trigger]')) {
          e.preventDefault();
          const modalId = e.target.getAttribute('data-modal-trigger');
          console.log('Modal trigger clicked, modalId:', modalId);
          this.openModal(modalId);
        }

        if (e.target.matches('[data-modal-close]')) {
          e.preventDefault();
          const modalId = e.target.getAttribute('data-modal-close');
          console.log('Close button clicked, modalId:', modalId);
          this.closeModal(modalId);
        }
        
        if (e.target.closest('[data-modal-close]')) {
          console.log('Close button or child clicked');
          const closeButton = e.target.closest('[data-modal-close]');
          const modalId = closeButton.getAttribute('data-modal-close');
          console.log('Close button found via closest, modalId:', modalId);
          e.preventDefault();
          this.closeModal(modalId);
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.activeModal) {
          this.closeModal(this.activeModal);
        }
      });
    }

    openModal(modalId) {
      console.log('openModal called with:', modalId);
      const modal = document.getElementById(modalId);
      if (!modal) {
        console.log('Modal not found:', modalId);
        return;
      }

      if (this.activeModal) {
        this.closeModal(this.activeModal);
      }

      this.activeModal = modalId;
      
      const originalParent = modal.parentElement;
      if (originalParent) {
        modal.dataset.originalParent = `[data-modal-original-parent="${modalId}"]`;
        originalParent.setAttribute('data-modal-original-parent', modalId);
      }
      
      this.modals.set(modalId, modal);

      document.body.appendChild(modal);
      modal.hidden = false;
      
      requestAnimationFrame(() => {
        modal.setAttribute('aria-hidden', 'false');
      });
      
      document.body.style.overflow = 'hidden';
      
      setTimeout(() => {
        modal.focus();
      }, 100);
    }

    closeModal(modalId) {
      console.log('closeModal called with:', modalId);
      const modal = document.getElementById(modalId);
      if (!modal) {
        console.log('Modal not found:', modalId);
        return;
      }

      modal.setAttribute('aria-hidden', 'true');
      
      setTimeout(() => {
        modal.hidden = true;
        
        if (this.modals.has(modalId)) {
          const originalParent = this.modals.get(modalId).dataset.originalParent;
          if (originalParent) {
            const parentElement = document.querySelector(originalParent);
            if (parentElement) {
              parentElement.appendChild(modal);
            }
          }
        }
      }, 300);

      if (this.activeModal === modalId) {
        this.activeModal = null;
      }

      document.body.style.overflow = '';
      
      this.modals.delete(modalId);
    }
  }

  if (typeof window !== 'undefined') {
    window.modal = new Modal();
  }
  } catch(e) { console.error(e); }
})();

})();
